import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class DoctorBillingService {

  constructor(private apiService: ApiService) { }

  public TransferActuaciones(date: string): Observable<any> {
    let url = `${API.DoctorBilling.transferActuaciones}/${date}`;    
    return  this.apiService.post(url);
  }

  public TransferOtrosGastos(): Observable<any> {
    let url = `${API.DoctorBilling.transferOtrosGastos}`;    
    return  this.apiService.post(url);
  }

  public Cerrarfacturacion(date: string): Observable<any> {
    let url = `${API.DoctorBilling.cerrarfacturacion}/${date}`;    
    return  this.apiService.post(url);
  }


  public CreateBill(): Observable<any> {
    let url = `${API.DoctorBilling.createBill}`;    
    return  this.apiService.post(url);
  }
  public getInitialDates(): Observable<RestResponse> {
    const url = `${API.Gastos.getInitialDate}`;
    return this.apiService.get(url);
  }

  
  GenerateReport(id: any): Observable<RestResponse> {
    let url = `${API.DoctorBilling.generateReport}`;   
    url = url.replace('{id}', id);    
    return this.apiService.get(url);
   } 

   GenerateReportForAll(): Observable<RestResponse> {
    let url = `${API.DoctorBilling.generateReportForAll}`
    return this.apiService.get(url);
   } 


}
